module.exports = __webpack_public_path__ + "static/mobile-logo-9bfaf5b875749f3c3e9c9fd1dace4687.png";